import { createAction } from 'redux-actions';

const ACTIONS_NAMESPACE = 'REGISTER_FLOW_STATE';

export const SET_MANUAL_FACEBOOK_EMAIL = `${ACTIONS_NAMESPACE}__SET_MANUAL_FACEBOOK_EMAIL`;
export const RESET_REGISTER_FLOW_STATE = `${ACTIONS_NAMESPACE}__RESET_REGISTER_FLOW_STATE`;


export const setManualFacebookEmail = createAction(SET_MANUAL_FACEBOOK_EMAIL, email => ({ email }));
export const resetRegisterFlowState = createAction(RESET_REGISTER_FLOW_STATE);
